export var REACTIONS = [
    {
        id: ':lolol:',
        code: '&#128514',
    },
    {
        id: ':thumbsup:',
        code: '&#128077',
    },
    {
        id: ':fire:',
        code: '&#128293',
    },
    {
        id: ':raisedhand:',
        code: '&#9995',
    },
    {
        id: ':heart:',
        code: '&#10084;&#65039;',
    },
];
//# sourceMappingURL=reactions.js.map